import {UmpireSquad} from '../umpire-squad';

export interface UmpireCompetitionsSquad {
  id: string;
  type: 'competitions_squad';
  squad?: UmpireSquad;
  squads?: UmpireSquad[];
  relationshipNames: string[];
}
